import { render, staticRenderFns } from "./Sending.vue?vue&type=template&id=8c71bff0&scoped=true"
var script = {}
import style0 from "./Sending.vue?vue&type=style&index=0&id=8c71bff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c71bff0",
  null
  
)

export default component.exports